import React, { useContext, useCallback } from 'react';
import _ from 'lodash';
import { BreakpointTrackerContext } from '@jutro/layout';
import { wizardProps } from '@xengage/gw-portals-wizard-react';
import { ViewModelServiceContext, ViewModelForm } from '@xengage/gw-portals-viewmodel-react';
import { useValidation } from '@xengage/gw-portals-validation-react';
import { readViewModelValue } from '@xengage/gw-jutro-adapters-react';
import { withRouter } from 'react-router-dom';


import metadata from './ScheduledArticleTableComponent.metadata.json5';
// import PriorProjectComponent from '../SubComponents/PriorProject/PriorProjectComponent';
import ScheduledArticlesComponent from '../ScheduledArticles/ScheduledArticlesComponent';
import styles from "../../../SpecialtyPersonalStyles.module.scss";

function ScheduledArticleTableComponent(props) {

    const { submissionVM, updateWizardData, pathUpdated, index } = props;
    const breakpoint = useContext(BreakpointTrackerContext);
    const { onValidate } = useValidation('ScheduledArticleTableComponent');
    const modelVM = _.get(submissionVM, pathUpdated);

    const viewModelService = useContext(ViewModelServiceContext);
    

    if(modelVM.value !== undefined) {
        modelVM.value.isValidationReq = true
    }   



    // eslint-disable-next-line react-hooks/exhaustive-deps
    const overrideProps = {
        '@field': {
            showRequired: true,
            labelPosition: breakpoint === 'desktop' ? 'left' : 'top'
        },
        scheduledArticlesComponent:{
            data: modelVM,
            updateWizardData,
            index,
            viewModelService,
            submissionVM,
            scheduledArticlesTablePath: `${pathUpdated}`,
        },
    };


    const resolvers = {
        resolveCallbackMap: {
            onValidate
        },
        resolveComponentMap: {
            scheduledArticlesComponent: ScheduledArticlesComponent
        },
        resolveClassNameMap: styles,
    };

    const readValue = useCallback(
        (id, path) => readViewModelValue(metadata.componentContent, _.get(submissionVM, pathUpdated), id, path, overrideProps),
        [overrideProps, pathUpdated, submissionVM]
    );

    const handleValueChange = useCallback(
        (value, changedPath) => {
            const fullPath = `${pathUpdated}.${changedPath}`;

            _.set(submissionVM, `${fullPath}`, value);

            updateWizardData(submissionVM);
        },
        [pathUpdated, submissionVM, updateWizardData]
    );

    return (
        <ViewModelForm
            uiProps={metadata.componentContent}
            model={modelVM}
            // onModelChange={updateWizardData}
            resolveValue={readValue}
            overrideProps={overrideProps}
            onValidationChange={onValidate}
            onValueChange={handleValueChange}
            callbackMap={resolvers.resolveCallbackMap}
            componentMap={resolvers.resolveComponentMap}
            classNameMap={resolvers.resolveClassNameMap}
        />
    );
}

ScheduledArticleTableComponent.propTypes = wizardProps;
export default withRouter(ScheduledArticleTableComponent);
